import { useState, useEffect, useRef,  } from "react";
import {
  Page,
  Navbar,
  BtnBlock,
  DialogBox,
  BtnSmall,
  Loader,
  BtnSmallDisabled,
} from "../components";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as ROUTES from "../constant/routes";
import { getAllExpiredBooks, wallet } from "../assets/Js/script";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";


export default function ExpiringSoon() {
  const [modals, setModals] = useState({
    expandedMenu: true,
    isLoading: true,
    filter: false,
    renew: false,
    validity: false,
    hostingCharges: false,
  });
  const [filter, setFilter] = useState({
    selected: "Expiring soon",
  });
  const notify = (message) => toast(message);
  const navigate = useNavigate(); 
  const [toBeRenewed, setToBeRenewed] = useState(null);
  const [books, setBooks] = useState([]);
  const [walletDetails, setWalletDetails] = useState(null);
  const [inSufficientBalance, setInSufficientBalance] = useState(false);
  const [information, setInformation] = useState(false);

  const [payment, setPayment] = useState({
    enable: false,
    currentStep: 1,
    toPay: 0,
  });

  const [paid, setPaid] = useState(false);
  const [confirmOTP, setConfirmOTP] = useState(false);
  const [percentage, setPercentage] = useState();
  const [daysToExpire, setDayToExpire] = useState();
  const [otp, setOtp] = useState({
    otpFirst: "",
    otpSecond: "",
    otpThird: "",
    otpFourth: "",
    otpFifth: "",
    otpSixth: "",
  });

  const firstInputRef = useRef(null);
  const secondInputRef = useRef(null);
  const thirdInputRef = useRef(null);
  const fourthInputRef = useRef(null);
  const fifthInputRef = useRef(null);
  const sixthInputRef = useRef(null);

  function handleOTP(e) {
    const { name, value } = e.target;
    if (otp[name].length <= 1) {
      setOtp((prevState) => ({ ...prevState, [name]: value }));
    }
  }

  const [timeRemaining, setTimeRemaining] = useState(60);
  const [resend, setResend] = useState(false);

  function handleResendOtp() {
    setResend(false);
    setTimeRemaining(60);
    let remaining = 60;
    let resendTimer = setInterval(() => {
      setTimeRemaining(remaining--);
      if (remaining < 1) {
        clearInterval(resendTimer);
        setResend(true);
      }
    }, 1000);
  }

  useEffect(() => {
    if (paid) {
      let remaining = 60;
      let resendTimer = setInterval(() => {
        setTimeRemaining(remaining--);

        if (remaining < 1 || payment.currentStep !== 3) {
          clearInterval(resendTimer);
          setResend(true);
        }
      }, 1000);
    }
  }, [paid]);

  useEffect(() => {
    walletDetails && setPaid(payment.toPay > walletDetails.myCredits.credits);
  }, [payment]);

  useEffect(() => {
    for (const key in otp) {
      if (otp[key] === "") {
        if (key === "otpFirst") {
          firstInputRef.current && firstInputRef.current.focus();
        } else if (key === "otpSecond") {
          secondInputRef.current && secondInputRef.current.focus();
        } else if (key === "otpThird") {
          thirdInputRef.current && thirdInputRef.current.focus();
        } else if (key === "otpFourth") {
          fourthInputRef.current && fourthInputRef.current.focus();
        } else if (key === "otpFifth") {
          fifthInputRef.current && fifthInputRef.current.focus();
        } else if (key === "otpSixth") {
          sixthInputRef.current && sixthInputRef.current.focus();
        }
        setConfirmOTP(false);
        break;
      } else {
        setConfirmOTP(true);
      }
    }
  }, [otp]);

  function handleRenewBook(book) { }

  async function getWallet() {
    const { response, error } = await wallet();
    if (response.status === "success") {
      setWalletDetails({ ...response.data });
      setModals((prevState) => ({ ...prevState, isLoading: false }));
    }
  }

  useEffect(() => {
    async function temp() {
      setModals((prevState) => ({ ...prevState, isLoading: true }));
      let sortBy;
      switch (filter.selected) {
        case "Expiring soon":
          sortBy = "expiringSoon";
          break;

        case "Expired":
          sortBy = "expired";
          break;

        case "Deactivating soon":
          sortBy = "deactivingSoon";
          break;

        case "Deactivated":
          sortBy = "deactivated";
          break;

        default:
          sortBy = "";
          break;
      }
      const { response, error } = await getAllExpiredBooks(sortBy);
      if (response.status === "success") {
        setModals((prevState) => ({ ...prevState, isLoading: false }));
        setBooks([...response.data.books]);
      }else {
        notify(response?.message ? response?.message : "Something went wrong");
        setModals((prevState) => ({ ...prevState, isLoading: false }));
      }
      await getWallet();
    }
    temp();
  }, [filter]);

  useEffect(() => {
    function handleDialogBox() {
      setModals((prevState) => ({ ...prevState, filter: false }));
      setInformation(false);
    }
    document.addEventListener("click", handleDialogBox);

    return () => {
      document.removeEventListener("click", handleDialogBox);
    };
  }, []);

  useEffect(() => {
    function prograsBar() {
      var a = moment(moment().format("YYYY, M, DD"));
      var b = moment(moment(books[0]?.expiresOn).format("YYYY, M, DD"));
      const DateValue = b.diff(a, "days");
      const perValue = Math.ceil(DateValue / 0.3);
      setDayToExpire(DateValue);
      setPercentage(perValue);
    }

    prograsBar();
  }, [daysToExpire, percentage, books]);

  return (
    <Page active="">
      <Navbar />
      {modals.isLoading ? (
        <Loader show={modals.isLoading} />
      ) : (
        <>
          <div className="relative flex justify-between items-center">
            <h1 className="flex gap-2 items-center text-heading text-h1 font-semibold text-left my-8">
              Book Expiry
              <button
                onMouseEnter={(e) => {
                  setInformation(true);
                }}
                className=""
              >
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 18C12.6522 18 15.1957 17.0518 17.0711 15.364C18.9464 13.6761 20 11.3869 20 9C20 6.61305 18.9464 4.32387 17.0711 2.63604C15.1957 0.948212 12.6522 0 10 0C7.34784 0 4.8043 0.948212 2.92893 2.63604C1.05357 4.32387 0 6.61305 0 9C0 11.3869 1.05357 13.6761 2.92893 15.364C4.8043 17.0518 7.34784 18 10 18ZM11.1625 7.4115L9.9125 12.7046C9.825 13.0871 9.94875 13.3043 10.2925 13.3043C10.535 13.3043 10.9012 13.2255 11.15 13.0275L11.04 13.4955C10.6812 13.8848 9.89 14.1683 9.20875 14.1683C8.33 14.1683 7.95625 13.6935 8.19875 12.6844L9.12125 8.78288C9.20125 8.45325 9.12875 8.334 8.7625 8.25412L8.19875 8.163L8.30125 7.73438L11.1637 7.4115H11.1625ZM10 6.1875C9.66848 6.1875 9.35054 6.06897 9.11612 5.858C8.8817 5.64702 8.75 5.36087 8.75 5.0625C8.75 4.76413 8.8817 4.47798 9.11612 4.267C9.35054 4.05603 9.66848 3.9375 10 3.9375C10.3315 3.9375 10.6495 4.05603 10.8839 4.267C11.1183 4.47798 11.25 4.76413 11.25 5.0625C11.25 5.36087 11.1183 5.64702 10.8839 5.858C10.6495 6.06897 10.3315 6.1875 10 6.1875Z"
                    fill="#C5C5C5"
                  />
                </svg>
              </button>
            </h1>
            <div className="flex justify-between items-center relative">
              <p className="mr-6 font-semibold text-[18px] leading-[22px] text-[#a1a1a0]">
                Sort by
              </p>
              <button
                className="flex items-center font-semibold justify-between px-4 bg-[#dbdbdb] text-secondary-dark w-[151px] h-[37px]"
                onClick={(e) => {
                  e.stopPropagation();
                  setModals((prevState) => ({ ...prevState, filter: true }));
                }}
              >
                {filter.selected}
                <span>
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="18" height="15" rx="2" fill="#FFD600" />
                    <path d="M9.5 11L5 5H14L9.5 11Z" fill="#7A7976" />
                  </svg>
                </span>
              </button>
              {modals.filter && (
                <div
                  className="absolute top-9 w-[151px] right-0 bg-primary-white"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="w-full text-left px-4 h-[34px] hover:bg-[#f0f0f0] text-secondary-light leading-[19px] font-medium"
                    onClick={() => {
                      setFilter((prevState) => ({
                        ...prevState,
                        selected: "Expiring soon",
                      }));
                      setModals((prevState) => ({
                        ...prevState,
                        filter: false,
                      }));
                    }}
                  >
                    Expiring soon
                  </button>
                  <button
                    className="w-full text-left px-4 h-[34px] hover:bg-[#f0f0f0] text-secondary-light leading-[19px] font-medium"
                    onClick={() => {
                      setFilter((prevState) => ({
                        ...prevState,
                        selected: "Expired",
                      }));
                      setModals((prevState) => ({
                        ...prevState,
                        filter: false,
                      }));
                    }}
                  >
                    Expired
                  </button>
                  <button
                    className="w-full text-left pl-4 h-[34px] hover:bg-[#f0f0f0] text-secondary-light leading-[19px] font-medium"
                    onClick={() => {
                      setFilter((prevState) => ({
                        ...prevState,

                        selected: "Deactivating soon",
                      }));
                      setModals((prevState) => ({
                        ...prevState,
                        filter: false,
                      }));
                    }}
                  >
                    Deactivating soon
                  </button>
                  <button
                    className="w-full text-left px-4 h-[34px] hover:bg-[#f0f0f0] text-secondary-light leading-[19px] font-medium"
                    onClick={() => {
                      setFilter((prevState) => ({
                        ...prevState,

                        selected: "Deactivated",
                      }));
                      setModals((prevState) => ({
                        ...prevState,
                        filter: false,
                      }));
                    }}
                  >
                    Deactivated
                  </button>
                </div>
              )}
            </div>
            {information && (
              <div onClick={(e) => e.stopPropagation()} className=" absolute top-[54px] left-[190px] py-1 px-3 border-1 border-solid border-[#000] bg-[#fbfafb] z-40 shadow-md">
                <p className="flex w-full justify-between font-[500] text-[15px] font-[Cabin] text-[#00000063] mb-3">
                  Fiilter guide:
                  <button onClick={() => {
                    setInformation(false)
                  }} className="absolue top-0 right-0 z-40">
                    <svg
                      width="12"
                      height="11"
                      viewBox="0 0 12 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5431 10.6224C11.2563 10.8602 10.8672 10.9937 10.4615 10.9937C10.0559 10.9937 9.66679 10.8602 9.37993 10.6224L6.00064 7.42157L2.62135 10.6214C2.47973 10.7407 2.31102 10.8355 2.12494 10.9005C1.93886 10.9655 1.73909 10.9993 1.53717 11C1.33524 11.0007 1.13515 10.9682 0.948441 10.9045C0.761728 10.8408 0.592087 10.747 0.449303 10.6287C0.30652 10.5104 0.193419 10.3698 0.116525 10.2151C0.0396308 10.0603 0.000465091 9.89451 0.00128731 9.72717C0.00210953 9.55983 0.0429031 9.39428 0.121315 9.24007C0.199727 9.08586 0.314206 8.94605 0.458148 8.82868L3.97383 5.50106L0.456873 2.17131C0.312932 2.05395 0.198453 1.91414 0.120041 1.75993C0.0416285 1.60572 0.000834902 1.44017 1.26821e-05 1.27283C-0.000809538 1.10549 0.0383562 0.939671 0.11525 0.784938C0.192144 0.630205 0.305245 0.489619 0.448029 0.371291C0.590813 0.252963 0.760454 0.159234 0.947167 0.0955104C1.13388 0.0317866 1.33397 -0.000670882 1.53589 1.051e-05C1.73782 0.000691902 1.93758 0.0344985 2.12366 0.0994803C2.30975 0.164462 2.47846 0.259333 2.62008 0.378621L6.00064 3.58054L9.37993 0.378621C9.52154 0.259333 9.69026 0.164462 9.87634 0.0994803C10.0624 0.0344985 10.2622 0.000691902 10.4641 1.051e-05C10.666 -0.000670882 10.8661 0.0317866 11.0528 0.0955104C11.2395 0.159234 11.4092 0.252963 11.552 0.371291C11.6948 0.489619 11.8079 0.630205 11.8848 0.784938C11.9616 0.939671 12.0008 1.10549 12 1.27283C11.9992 1.44017 11.9584 1.60572 11.88 1.75993C11.8015 1.91414 11.6871 2.05395 11.5431 2.17131L8.02745 5.50106L11.5431 8.82868C11.6854 8.94642 11.7982 9.08623 11.8752 9.24012C11.9521 9.39401 11.9918 9.55897 11.9918 9.72556C11.9918 9.89215 11.9521 10.0571 11.8752 10.211C11.7982 10.3649 11.6854 10.5047 11.5431 10.6224Z"
                        fill="black"
                        fill-opacity="0.53"
                      />
                    </svg>
                  </button>
                </p>
                <p className="font-[500] text-[15px] font-[Cabin] text-[#00000042]">
                  {"a) "}ACTIVE means that the book is still in it’s valdity
                  period and doesn’t need any immediate action.
                </p>
                <p className="font-[500] text-[15px] font-[Cabin] text-[#00000042]">
                  {"b)"} EXPIRING SOON means that the book is still in it’s validity period, however, it needs to be UPGRADED.
                </p>
                <p className="font-[500] text-[15px] font-[Cabin] text-[#00000042]">
                  {"c)"} EXPIRED means that the book is no longer in in it’s validity period
                </p>
                <p className="font-[500] text-[15px] font-[Cabin] text-[#00000042]">
                  {"d)"} DEACTIVATING SOON
                </p>
                <p className="font-[500] text-[15px] font-[Cabin] text-[#00000042]">
                  {" e)"} DEACTIVATED
                </p>
              </div>
            )}
          </div>

          {books?.length > 0 ? (
            books.map((book) => (
              <div onClick={() => navigate(`/books/${book.parentId}`)} className="p-4 flex justify-between items-center w-full h-40 border-1 border-solid border-primary-dark-20 mb-6">
                <div className="flex">
                  <div style={{ background: book.backgroundColor }} className="bg-neutral-10 w-[107px] h-32 flex justify-center items-center">
                    <img
                      className=" h-[80%] w-[80%] object-cover shadow-[5px_5px_13px_3px_rgba(0,0,0,0.5)]"
                      src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${book.imageCoverFront}`}
                      alt="front cover"
                    />
                  </div>
                  <div className="py-4 px-4 flex flex-col justify-between">
                    <p className="text-montserrat uppercase font-bold leading-[19.5px] mb-2 text-secondary-light ">
                      {book.id}
                    </p>
                    <h3 className="text-heading text-left font-semibold text-h5">
                      {book.title}
                    </h3>
                    <p className="text-p1 text-secondary-dark font-semibold">
                      {book.Bauthors?.map(
                        (auther, index, arr) => <span>{
                          (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                        }</span>
                      )}
                    </p>
                    <div className="flex items-center">
                      <div className="w-32 h-2 bg-[#BB7AAF] rounded-full">
                        <div
                          className={` h-2 bg-primary-dark rounded-full`}
                          style={{ width: percentage + "%" }}
                        ></div>
                      </div>
                      <p className="text-sm text-secondary-light ml-4">
                        in {daysToExpire} Days
                      </p>
                    </div>
                  </div>
                </div>
                {/* <button
                  onClick={() => {
                    handleRenewBook(book);
                    setModals((prevState) => ({ ...prevState, renew: true }));
                  }}
                  className="border-1 border-solid border-primary-dark-20 text-p1 font-semibold w-[183px] h-12"
                >
                  Renew
                </button> */}
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center w-full h-[70%]">
              {/* <svg
                width="101"
                height="92"
                viewBox="0 0 101 92"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M96.1892 39.4297H96.2902C98.0297 39.4297 99.6008 40.1657 100.723 41.3541C101.883 42.5079 102.601 44.1179 102.601 45.9004V46.0077V46.1074C102.601 47.8899 101.883 49.4999 100.723 50.6499C99.5971 51.8382 98.0259 52.5742 96.2865 52.5742H96.1818H95.4336L89.6691 86.5721C89.4251 88.1002 88.6441 89.484 87.4733 90.4629L87.4621 90.4706C86.3773 91.4251 84.9558 92.0077 83.4034 92.0077H19.1861C17.6337 92.0077 16.2122 91.4251 15.1199 90.4629L15.1274 90.4706C13.9604 89.4992 13.1786 88.1256 12.9278 86.6066L12.9241 86.5682L7.15962 52.5704H6.30673C4.56728 52.5704 2.99617 51.8344 1.87395 50.6461C1.27897 50.0564 0.806049 49.3499 0.483411 48.5688C0.160772 47.7877 -0.00496337 46.9479 -0.00390118 46.0997V45.9924V45.8927C-0.00390118 44.1102 0.714321 42.5002 1.87395 41.3502C2.99991 40.1619 4.57102 39.4259 6.31047 39.4259H6.41521H6.41147L96.1892 39.4297ZM24.281 80.5001C24.7007 80.4707 25.1101 80.3535 25.4839 80.1558C25.8577 79.958 26.188 79.6838 26.4544 79.3501L26.4581 79.3462C26.7423 79.0229 26.9581 78.6428 27.092 78.2298C27.2259 77.8168 27.275 77.3799 27.2362 76.9466V76.9581L25.6314 55.5987C25.6028 55.1686 25.4884 54.7491 25.2954 54.366C25.1024 53.983 24.8348 53.6445 24.5092 53.3716L24.5054 53.3677C24.1899 53.0765 23.8189 52.8554 23.4159 52.7181C23.0129 52.5809 22.5866 52.5306 22.1637 52.5704H22.1749C21.7552 52.5998 21.3458 52.7169 20.972 52.9147C20.5982 53.1125 20.2679 53.3867 20.0016 53.7204L19.9978 53.7242C19.7137 54.0476 19.4978 54.4277 19.3639 54.8407C19.23 55.2537 19.1809 55.6906 19.2198 56.1239V56.1124L20.8245 77.4717C20.8779 78.2996 21.2459 79.0731 21.8495 79.6261L21.8532 79.6299C22.4307 80.1916 23.1967 80.5045 23.9929 80.5039H24.0341H24.0304L24.281 80.5001ZM44.8738 77.2187V55.8594V55.8287C44.875 55.4029 44.7913 54.9813 44.6279 54.5898C44.4646 54.1982 44.2249 53.845 43.9236 53.5517C43.6364 53.2433 43.291 52.9979 42.9084 52.8305C42.5258 52.6631 42.1139 52.5772 41.6979 52.5781H41.638C41.2225 52.5768 40.8111 52.6626 40.429 52.83C40.0469 52.9974 39.7022 53.243 39.416 53.5517C39.115 53.846 38.8755 54.2 38.7122 54.5921C38.5488 54.9842 38.465 55.4062 38.4659 55.8326V77.2532C38.4659 78.1502 38.8287 78.9591 39.416 79.5302C39.7032 79.8387 40.0486 80.0841 40.4312 80.2515C40.8139 80.4189 41.2257 80.5048 41.6418 80.5039H41.7016C42.1172 80.5051 42.5286 80.4194 42.9106 80.252C43.2927 80.0846 43.6374 79.839 43.9236 79.5302C44.2287 79.236 44.4718 78.8807 44.6378 78.4865C44.8038 78.0922 44.8892 77.6673 44.8887 77.2379V77.2149L44.8738 77.2187ZM64.1124 77.2187V55.8594V55.8287C64.1136 55.4029 64.0299 54.9813 63.8666 54.5898C63.7032 54.1982 63.4635 53.845 63.1622 53.5517C62.8751 53.2433 62.5297 52.9979 62.147 52.8305C61.7644 52.6631 61.3525 52.5772 60.9365 52.5781H60.8766C60.4611 52.5768 60.0497 52.6626 59.6676 52.83C59.2855 52.9974 58.9408 53.243 58.6546 53.5517C58.3536 53.846 58.1141 54.2 57.9508 54.5921C57.7875 54.9842 57.7037 55.4062 57.7045 55.8326V77.2532C57.7045 78.1502 58.0674 78.9591 58.6546 79.5302C58.9418 79.8387 59.2872 80.0841 59.6699 80.2515C60.0525 80.4189 60.4643 80.5048 60.8804 80.5039H60.9402C61.3558 80.5051 61.7672 80.4194 62.1493 80.252C62.5313 80.0846 62.876 79.839 63.1622 79.5302C63.4674 79.236 63.7104 78.8807 63.8764 78.4865C64.0424 78.0922 64.1278 77.6673 64.1273 77.2379V77.2149L64.1124 77.2187ZM81.7462 77.4717L83.351 56.1124C83.3872 55.6804 83.3369 55.2454 83.2031 54.8341C83.0693 54.4227 82.8548 54.0437 82.5729 53.7204L82.5767 53.7242C82.311 53.3901 81.9815 53.1151 81.6084 52.916C81.2354 52.717 80.8265 52.598 80.4071 52.5666H80.3958C79.9743 52.5295 79.5498 52.5811 79.1484 52.7182C78.747 52.8553 78.3771 53.075 78.0616 53.3639L78.0653 53.3601C77.7393 53.6324 77.4709 53.97 77.2767 54.3523C77.0824 54.7346 76.9664 55.1535 76.9356 55.5834V55.5949L75.3309 76.9542C75.2947 77.3862 75.345 77.8213 75.4788 78.2326C75.6126 78.6439 75.827 79.0229 76.1089 79.3462L76.1052 79.3424C76.3709 79.6765 76.7004 79.9516 77.0735 80.1506C77.4465 80.3497 77.8553 80.4686 78.2748 80.5001H78.5741C79.3713 80.5001 80.1383 80.1873 80.7175 79.6261C81.3288 79.0737 81.7037 78.2972 81.7612 77.4641V77.4526L81.7462 77.4717ZM23.8471 14.9884L19.1898 36.1407H12.5762L17.6337 13.5011C18.2434 10.4919 19.8407 7.94274 22.0552 6.16024L22.0814 6.14108C24.31 4.28909 27.0939 3.28175 29.9632 3.28908H30.1053H30.0978H38.4621V3.25841C38.4621 2.36141 38.825 1.55258 39.4123 0.98141C39.6997 0.671937 40.0456 0.425671 40.4289 0.257618C40.8122 0.0895639 41.2249 0.00324152 41.6418 0.0039101H60.9515C61.8268 0.0039101 62.6161 0.375743 63.1735 0.977577C63.4745 1.27185 63.714 1.62581 63.8773 2.01791C64.0407 2.41002 64.1245 2.83207 64.1236 3.25841V3.28908H72.6263C75.6227 3.28908 78.3721 4.36241 80.5268 6.15641L80.5043 6.13724C82.7735 7.95202 84.3436 10.5304 84.9371 13.4167L84.952 13.4972L90.0095 36.1369H83.3959L78.7387 14.9846C78.4001 13.533 77.6032 12.2366 76.4718 11.2969L76.4606 11.2854C75.3596 10.3537 73.9756 9.84524 72.5478 9.84791H64.1124V9.87858C64.1136 10.3044 64.0299 10.726 63.8666 11.1175C63.7032 11.5091 63.4635 11.8623 63.1622 12.1556C62.8751 12.4641 62.5297 12.7095 62.147 12.8769C61.7644 13.0442 61.3525 13.1301 60.9365 13.1292H41.6418C41.2262 13.1305 40.8148 13.0448 40.4327 12.8773C40.0507 12.7099 39.706 12.4643 39.4198 12.1556C39.1187 11.8613 38.8792 11.5073 38.7159 11.1152C38.5526 10.7231 38.4688 10.3011 38.4696 9.87474V9.84408H30.0342C28.603 9.84242 27.2162 10.3536 26.1139 11.2892L26.1252 11.2816C25.0019 12.2138 24.2093 13.4989 23.8695 14.9386L23.862 14.9846L23.8471 14.9884Z"
                  fill="#726D6D"
                  fill-opacity="0.33"
                />
              </svg> */}
              <p className="text-secondary-light text-montserrat font-semibold leading-[29px] text-h1">
                Book Expired is empty.
              </p>
            </div>
          )}
          {modals.renew && (
            <DialogBox show={modals.renew}>
              <div className="bg-primary-white w-[475px] h-[437px] relative p-8 flex flex-col">
                <p className="leading-[24px] text-montserrat font-bold text-[19px] leading-[24px] text-tertiary-dark ">
                  Book Renewal
                </p>
                <p className="mt-5 mb-8 leading-[24px] text-[rgba(0,0,0,0.5)]">
                  Choose the validity that you would like to buys for the
                  selected book and complete the renewal
                </p>
                <div className="flex items-center">
                  <p className="mr-20 font-medium text-[18px] leading-[25px] text-secondary-light">
                    Book Title
                  </p>
                  <p className="font-medium text-[18px] leading-[25px] text-heading-false">
                    The Mission Legal rights limited
                  </p>
                </div>
                <div className="my-5 flex items-center">
                  <p className="mr-[102px] font-medium text-[18px] leading-[25px] text-secondary-light">
                    Validity
                  </p>
                  <div>
                    <button className="bg-[#dbdbdb] w-[77px] h-[23px] flex items-center justify-evenly font-medium text-secondary-dark leading-[19px]">
                      1 year
                      <svg
                        width="17"
                        height="15"
                        viewBox="0 0 17 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="17" height="15" rx="2" fill="#FFD600" />
                        <path d="M8.5 10L4 6H13L8.5 10Z" fill="#7A7976" />
                      </svg>
                    </button>
                    {modals.validity && <div></div>}
                  </div>
                  <p className="ml-3 text-tertiary-dark font-medium leading-[24px]">
                    = 200 Tokens
                  </p>
                </div>
                <div className="relative flex items-center">
                  <p className="mr-[35px] font-medium text-[18px] leading-[25px] text-secondary-light">
                    Hosting charges
                  </p>
                  <p className="font-medium text-[18px] leading-[25px] text-heading-false">
                    0 Tokens
                  </p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setModals((prevState) => ({
                        ...prevState,
                        hostingCharges: true,
                      }));
                    }}
                    className="absolute left-[125px] top-[6.2px]"
                  >
                    <svg
                      width="17"
                      height="15"
                      viewBox="0 0 17 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.5 15C10.7543 15 12.9163 14.2098 14.5104 12.8033C16.1045 11.3968 17 9.48912 17 7.5C17 5.51088 16.1045 3.60322 14.5104 2.1967C12.9163 0.790176 10.7543 0 8.5 0C6.24566 0 4.08365 0.790176 2.48959 2.1967C0.895533 3.60322 0 5.51088 0 7.5C0 9.48912 0.895533 11.3968 2.48959 12.8033C4.08365 14.2098 6.24566 15 8.5 15ZM9.48812 6.17625L8.42562 10.5872C8.35125 10.9059 8.45644 11.0869 8.74862 11.0869C8.95475 11.0869 9.26606 11.0212 9.4775 10.8562L9.384 11.2463C9.07906 11.5706 8.4065 11.8069 7.82744 11.8069C7.0805 11.8069 6.76281 11.4113 6.96894 10.5703L7.75306 7.31906C7.82106 7.04437 7.75944 6.945 7.44813 6.87844L6.96894 6.8025L7.05606 6.44531L9.48919 6.17625H9.48812ZM8.5 5.15625C8.21821 5.15625 7.94796 5.05748 7.7487 4.88166C7.54944 4.70585 7.4375 4.46739 7.4375 4.21875C7.4375 3.97011 7.54944 3.73165 7.7487 3.55584C7.94796 3.38002 8.21821 3.28125 8.5 3.28125C8.78179 3.28125 9.05204 3.38002 9.2513 3.55584C9.45056 3.73165 9.5625 3.97011 9.5625 4.21875C9.5625 4.46739 9.45056 4.70585 9.2513 4.88166C9.05204 5.05748 8.78179 5.15625 8.5 5.15625Z"
                        fill="#C5C5C5"
                      />
                    </svg>
                  </button>
                  {modals.hostingCharges && (
                    <div className="px-4 py-2 flex flex-col justify-between absolute left-[150px] top-[0px] w-[276px] h-[131px] bg-[#fbfafb] border-1 border-solid border-[rgba(0,0,0,0.42)] shadow-[3px_3px_2px_rgba(135,133,133,0.13)]">
                      <p className="text-secondary-light italic font-medium text-[13px] leading-[18px]">
                        Hosting charges lorem ipsum uibsi cons etet ur adip
                        iscing.
                      </p>
                      <p className="text-tertiary-dark text-[13px] font-medium leading-[19px]">
                        20 Tokens/1000 Pages
                      </p>
                      <p className="text-secondary-light italic font-medium text-[13px] leading-[18px]">
                        Buffer charges are also included here which lorem ipsum
                        are also included here which lorem ipsum.
                      </p>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setModals((prevState) => ({
                            ...prevState,
                            hostingCharges: false,
                          }));
                        }}
                        className="absolute right-1 top-2"
                      >
                        <svg
                          width="6"
                          height="5"
                          viewBox="0 0 6 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.26961 4.82838C5.1422 4.93643 4.96939 4.99714 4.7892 4.99714C4.60902 4.99714 4.43621 4.93643 4.3088 4.82838L2.80784 3.37344L1.30689 4.8279C1.24398 4.88212 1.16905 4.92524 1.0864 4.95478C1.00375 4.98432 0.91502 4.99969 0.825332 5C0.735644 5.00031 0.646772 4.98555 0.563841 4.95659C0.48091 4.92762 0.405561 4.88502 0.342142 4.83123C0.278723 4.77745 0.228488 4.71354 0.194334 4.64321C0.160181 4.57288 0.142785 4.4975 0.14315 4.42144C0.143515 4.34538 0.161634 4.27013 0.196462 4.20003C0.23129 4.12994 0.282137 4.06638 0.346071 4.01304L1.90761 2.50048L0.345504 0.986961C0.281571 0.933616 0.230723 0.870062 0.195896 0.799967C0.161068 0.729872 0.142949 0.654623 0.142584 0.578559C0.142219 0.502495 0.159615 0.427123 0.193768 0.35679C0.227922 0.286457 0.278157 0.222554 0.341576 0.168769C0.404995 0.114983 0.480344 0.0723792 0.563275 0.0434138C0.646206 0.0144485 0.735078 -0.000304946 0.824766 4.77726e-06C0.914454 0.000314501 1.00318 0.0156811 1.08583 0.0452183C1.16848 0.0747555 1.24342 0.117879 1.30632 0.1721L2.80784 1.62752L4.3088 0.1721C4.3717 0.117879 4.44663 0.0747555 4.52928 0.0452183C4.61193 0.0156811 4.70066 0.000314501 4.79035 4.77726e-06C4.88004 -0.000304946 4.96891 0.0144485 5.05184 0.0434138C5.13477 0.0723792 5.21012 0.114983 5.27354 0.168769C5.33696 0.222554 5.38719 0.286457 5.42135 0.35679C5.4555 0.427123 5.4729 0.502495 5.47253 0.578559C5.47217 0.654623 5.45405 0.729872 5.41922 0.799967C5.38439 0.870062 5.33354 0.933616 5.26961 0.986961L3.70807 2.50048L5.26961 4.01304C5.33278 4.06655 5.38289 4.1301 5.41709 4.20005C5.45128 4.27001 5.46888 4.34499 5.46888 4.42071C5.46888 4.49643 5.45128 4.57141 5.41709 4.64136C5.38289 4.71132 5.33278 4.77487 5.26961 4.82838Z"
                            fill="black"
                            fill-opacity="0.53"
                          />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
                <div className="my-5 flex items-center">
                  <p className="mr-[57px] font-medium text-[18px] leading-[25px] text-secondary-light">
                    Total Charges
                  </p>
                  <p className="font-medium text-[18px] leading-[25px] text-heading-false">
                    200 Tokens
                  </p>
                </div>
                <div className="mt-2 flex justify-end">
                  <BtnSmall>Confirm</BtnSmall>
                </div>
                <button
                  onClick={() =>
                    setModals((prevState) => ({ ...prevState, renew: false }))
                  }
                  className="absolute top-8 right-8"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.6529 13.3035C12.3603 13.596 11.9636 13.7604 11.5498 13.7604C11.1361 13.7604 10.7393 13.596 10.4468 13.3035L7.00049 9.36448L3.55419 13.3022C3.40977 13.449 3.23771 13.5657 3.04794 13.6457C2.85817 13.7257 2.65444 13.7673 2.44851 13.7681C2.24258 13.7689 2.03852 13.729 1.84811 13.6506C1.65769 13.5722 1.48469 13.4568 1.33907 13.3112C1.19346 13.1656 1.07811 12.9926 0.999695 12.8022C0.921276 12.6117 0.881334 12.4077 0.882172 12.2018C0.883011 11.9958 0.924613 11.7921 1.00458 11.6023C1.08455 11.4126 1.2013 11.2405 1.34809 11.0961L4.93349 7.00108L1.34679 2.90348C1.2 2.75905 1.08325 2.58699 1.00328 2.39722C0.923313 2.20745 0.881711 2.00373 0.880872 1.7978C0.880034 1.59187 0.919976 1.38781 0.998395 1.19739C1.07681 1.00698 1.19216 0.833974 1.33777 0.688359C1.48339 0.542743 1.65639 0.4274 1.84681 0.348981C2.03722 0.270562 2.24128 0.23062 2.44721 0.231458C2.65314 0.232297 2.85687 0.273899 3.04664 0.353866C3.23641 0.433833 3.40847 0.550582 3.55289 0.697379L7.00049 4.63768L10.4468 0.697379C10.5912 0.550582 10.7633 0.433833 10.9531 0.353866C11.1428 0.273899 11.3465 0.232297 11.5525 0.231458C11.7584 0.23062 11.9625 0.270562 12.1529 0.348981C12.3433 0.4274 12.5163 0.542743 12.6619 0.688359C12.8075 0.833974 12.9229 1.00698 13.0013 1.19739C13.0797 1.38781 13.1197 1.59187 13.1188 1.7978C13.118 2.00373 13.0764 2.20745 12.9964 2.39722C12.9164 2.58699 12.7997 2.75905 12.6529 2.90348L9.0675 7.00108L12.6529 11.0961C12.7979 11.241 12.913 11.413 12.9915 11.6024C13.07 11.7918 13.1104 11.9948 13.1104 12.1998C13.1104 12.4048 13.07 12.6078 12.9915 12.7972C12.913 12.9865 12.7979 13.1586 12.6529 13.3035Z"
                      fill="black"
                      fill-opacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            </DialogBox>
          )}
          {payment.enable && (
            <DialogBox show={payment.enable}>
              <div className="bg-primary-white relative">
                <div className=" border-[1.5px] border-solid border-primary-dark-10 p-6  w-[902px] h-[370px] mt-3 mx-auto ">
                  {!paid ? (
                    <>
                      <h2 className="text-heading font-semibold text-left mb-3">
                        Payment
                      </h2>
                      <p className="text-secondary-light text-h5 text-justify mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        At aliquet ut facilisi nulla mauris iopsum. Pipsum dolor
                        sit ametre, consectetur adipiscing elit. At aliquet ut
                        facilisi nulla mauris.
                      </p>
                      <div className="flex items-center pl-4 mb-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                        <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                          &#8377;
                        </div>
                        <p className="text-h5 text-secondary-dark font-semibold">
                          Total Tokens available:{" "}
                          <span className="text-heading  ml-6">
                            {walletDetails.myCredits.credits}
                          </span>
                        </p>
                      </div>
                      <div className="mb-4 flex items-center pl-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                        <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                          &#8377;
                        </div>
                        <p className=" text-h5 text-secondary-dark font-semibold">
                          Amount to pay:{" "}
                          <span className="text-heading  ml-[73px]"></span>
                        </p>
                      </div>
                      {inSufficientBalance && (
                        <p className="flex items-center text-secondary-light text-h5 text-left mb-2">
                          <span className="mr-2">
                            <svg
                              width="25"
                              height="22"
                              viewBox="0 0 25 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0265 0C5.39521 0 0 4.85983 0 10.8333C0 16.8068 5.42058 21.6667 12.0833 21.6667C18.7461 21.6667 24.1667 16.8068 24.1667 10.8333C24.1667 4.85983 18.7207 0 12.0265 0ZM13.2917 16.25H10.875V14.0833H13.2917V16.25ZM13.2917 11.9167H10.875V5.41667H13.2917V11.9167Z"
                                fill="#FF3737"
                              />
                            </svg>
                          </span>
                          Your account balance is insufficient to complete this
                          transaction.
                          <RouterLink
                            to={ROUTES.WALLET}
                            className="ml-2 font-semibold text-tertiary-dark underline"
                          >
                            Add Money
                          </RouterLink>
                        </p>
                      )}
                      {inSufficientBalance ? (
                        <div className="flex justify-end items-center">
                          <BtnSmallDisabled>Pay</BtnSmallDisabled>
                        </div>
                      ) : (
                        <div className="flex justify-end items-center mt-10">
                          <BtnSmall>Pay</BtnSmall>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <h2 className="text-heading font-semibold text-left mb-4">
                        OTP has been sent for User Authentication
                      </h2>
                      <p className="text-secondary-light text-h5 text-justify mb-8">
                        One Time Password had been sent to your Mobile no. and
                        Email Address. Please enter the verification code.
                        Tibdolor sit ametre, consectetur adipiscing elit. At
                        aliquet ut facilisi nulla mauris.
                      </p>
                      <div className="flex items-center mb-8">
                        <input
                          type="number"
                          ref={firstInputRef}
                          onChange={handleOTP}
                          value={otp.otpFirst}
                          name="otpFirst"
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          onChange={handleOTP}
                          name="otpSecond"
                          ref={secondInputRef}
                          type="number"
                          value={otp.otpSecond}
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          onChange={handleOTP}
                          name="otpThird"
                          ref={thirdInputRef}
                          value={otp.otpThird}
                          type="number"
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          onChange={handleOTP}
                          name="otpFourth"
                          type="number"
                          value={otp.otpFourth}
                          ref={fourthInputRef}
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          onChange={handleOTP}
                          name="otpFifth"
                          type="number"
                          value={otp.otpFifth}
                          ref={fifthInputRef}
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          onChange={handleOTP}
                          name="otpSixth"
                          type="number"
                          value={otp.otpSixth}
                          ref={sixthInputRef}
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                      </div>

                      <p className="mb-6 text-left text-heading-false font-semibold text-p1">
                        Didn't receive the OTP?{" "}
                        {resend ? (
                          <button
                            onClick={handleResendOtp}
                            className="text-tertiary-dark font-semibold text-montserrat underline text-[19px]"
                          >
                            Resend
                          </button>
                        ) : (
                          <span className="text-secondary-light underline">
                            Resend in 0:
                            {timeRemaining < 10
                              ? `0${timeRemaining}`
                              : timeRemaining}
                          </span>
                        )}
                      </p>

                      {!confirmOTP ? (
                        <div className="flex justify-end items-center">
                          <BtnSmallDisabled>Submit</BtnSmallDisabled>
                        </div>
                      ) : (
                        <div className="flex justify-end">
                          <BtnSmall>Submit</BtnSmall>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <button
                  onClick={() =>
                    setPayment((prevState) => ({
                      ...prevState,
                      enable: false,
                      toPay: 0,
                    }))
                  }
                  className="absolute top-6 right-6"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.6529 13.4771C12.3603 13.7747 11.9636 13.9419 11.5498 13.9419C11.1361 13.9419 10.7393 13.7747 10.4468 13.4771L7.00049 9.46989L3.55419 13.4758C3.40977 13.6251 3.23771 13.7439 3.04794 13.8252C2.85817 13.9066 2.65444 13.9489 2.44851 13.9498C2.24258 13.9506 2.03852 13.91 1.84811 13.8302C1.65769 13.7504 1.48469 13.6331 1.33907 13.485C1.19346 13.3368 1.07811 13.1608 0.999695 12.9671C0.921276 12.7734 0.881334 12.5658 0.882172 12.3563C0.883011 12.1468 0.924613 11.9396 1.00458 11.7465C1.08455 11.5534 1.2013 11.3784 1.34809 11.2315L4.93349 7.06557L1.34679 2.89701C1.2 2.75009 1.08325 2.57505 1.00328 2.38199C0.923313 2.18894 0.881711 1.98168 0.880872 1.77219C0.880034 1.56269 0.919976 1.3551 0.998395 1.16139C1.07681 0.967674 1.19216 0.791673 1.33777 0.643536C1.48339 0.4954 1.65639 0.378059 1.84681 0.298282C2.03722 0.218505 2.24128 0.177871 2.44721 0.178724C2.65314 0.179577 2.85687 0.2219 3.04664 0.303252C3.23641 0.384604 3.40847 0.503374 3.55289 0.652712L7.00049 4.66124L10.4468 0.652712C10.5912 0.503374 10.7633 0.384604 10.9531 0.303252C11.1428 0.2219 11.3465 0.179577 11.5525 0.178724C11.7584 0.177871 11.9625 0.218505 12.1529 0.298282C12.3433 0.378059 12.5163 0.4954 12.6619 0.643536C12.8075 0.791673 12.9229 0.967674 13.0013 1.16139C13.0797 1.3551 13.1197 1.56269 13.1188 1.77219C13.118 1.98168 13.0764 2.18894 12.9964 2.38199C12.9164 2.57505 12.7997 2.75009 12.6529 2.89701L9.0675 7.06557L12.6529 11.2315C12.7979 11.3789 12.913 11.5539 12.9915 11.7466C13.07 11.9392 13.1104 12.1457 13.1104 12.3543C13.1104 12.5628 13.07 12.7694 12.9915 12.962C12.913 13.1547 12.7979 13.3297 12.6529 13.4771Z"
                      fill="black"
                      fill-opacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            </DialogBox>
          )}
        </>
      )}
      <ToastContainer
            position="top-right"
            autoClose={3000}
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
          />
    </Page>
  );
}
